import { render } from "./job-list.vue?vue&type=template&id=ba47d56c"
import script from "./job-list.vue?vue&type=script&lang=js"
export * from "./job-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__